import React, { useRef } from 'react';
import { Loading, Text, Button } from '../../components';
import FileUpload from '../../components/FileUpload';

const AnesthetistInsuranceCardForm = ({
	loading,
	currentInsuranceCard,
	onFileSelect,
	variant,
	onContinue,
	handleSkip
}) => {
	const fileInputRef = useRef(null);

	if (loading) {
		return <Loading />;
	}

	return (
		<div className="doca-flex doca-flex-col doca-w-full">
			<div className="doca-mb-4 doca-mt-6 doca-px-4">
				<label className="doca-steps__label">
					Passo 2 de 3
				</label>

				<div className="doca-steps__container">
					<div className={`doca-steps doca-mr-3 doca-w-full doca-steps--done doca-steps--${variant}`} />
					<div className={`doca-steps doca-mr-3 doca-w-full doca-steps--current doca-steps--${variant}`} />
					<div className={`doca-steps doca-mr-3 doca-w-full doca-steps--${variant}`} />
				</div>
			</div>

			<div className="doca-px-4">
				<Text size="large" weight="medium" marginBottom={16}>
					Carteirinha de Convênio
				</Text>
				<Text size="small" weight="normal" variant="gray" marginBottom={12}>
					Anexe sua carteirinha de convênio para prosseguirmos com o agendamento.
				</Text>
			</div>

			<div className="doca-px-4 doca-mt-4">
				<FileUpload
					ref={fileInputRef}
					onFileSelect={onFileSelect}
					defaultFile={currentInsuranceCard}
				/>

				<Text size="small" weight="normal" variant="gray" marginBottom={16} marginTop={16}>
					O arquivo deve ser um PDF, JPG ou PNG ou WEBP.
				</Text>
			</div>

			<div className="doca-px-4 doca-mt-4 doca-flex doca-flex-col doca-gap-3">
				<Button
					variant="primary"
					onClick={onContinue}
					block
					size="large"
					style={{ width: '100%' }}
				>
					Continuar
				</Button>


				<Button
					block
					size="large"
					variant="secondary"
					type="button"
					onClick={handleSkip}
				>
					<span>Pular</span>
					<i className="doca-icon doca-icon__arrow-right" />
				</Button>
			</div>
		</div>
	);
};

export default AnesthetistInsuranceCardForm;
